import { Grid, Stack } from '@mui/material';
import { DashboardActivityLog } from './DashboardActivityLog';
import { HotMembers } from '@app/dashboard/HotMembers';
import { MissionChart } from './MissionChart';
import { TasksList } from './TasksList';

export const Dashboard = () => {
    return (
        <Grid container spacing={2} mt={1} rowGap={4}>
            <Grid item xs={12} md={4}>
                <Stack gap={4}>
                    <DashboardActivityLog />
                </Stack>
            </Grid>

            <Grid item xs={12} md={5}>
                <Stack gap={4}>
                    <MissionChart />
                    <HotMembers />
                </Stack>
            </Grid>

            <Grid item xs={12} md={3}>
                <TasksList />
            </Grid>
        </Grid>
    );
};
